<template>
  <div class="exchange-currency-table-container">
    <CCard class="exchange-currency-list-table-card">
      <CDataTable :items="items" :fields="fields" fixed hover striped bordered>
        <template #platform="{item}">
          <td>
            {{item.platform | truncate(20)}}
          </td>
        </template>
        <template #symbol="{item}">
          <td>
            {{item.symbol | truncate(20)}}
          </td>
        </template>
        <template #name="{item}">
          <td>
            {{item.symbol | truncate(20)}}
          </td>
        </template>
        <template #icon="{item}">
          <td>
            <img v-if="item.icon" :src="item.icon" class="rounded currency-image" />
          </td>
        </template>

        <template #status_text="{item}">
          <td>
            <StakingBadge type="exchange-currency-status" :text="item.status_text" />
          </td>
        </template>
        <template #ms_status_text="{item}">
          <td>
            <StakingBadge type="exchange-currency-status" :text="item.ms_status_text" />
          </td>
        </template>

        <template #fix_rate_flg="{item}">
          <td>
            <CIcon v-if="item.fix_rate_flg" class="fixed-rate-icon" name="cil-check" />
            <!-- <div class="btn-switch-wrapper">
              <label class="btn-switch">
                <input type="checkbox" class="checkbox" v-model="item.fix_rate_flg" readonly="true" />
                <span class="check-silder"></span>
              </label>
            </div>-->
          </td>
        </template>

        <template #action="{item}">
          <td width="50px">
            <button class="btn btn-view-details" @click="viewDetails(item)">
              <img src="@/assets/images/ico-edit-user.svg" alt class="hand edit-icon" />
            </button>
          </td>
        </template>
      </CDataTable>
    </CCard>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import StakingBadge from '@/components/StakingBadge';
import { Constants } from '@/constants';

export default {
  name: 'ExchangeCurrencyListTable',
  components: {
    StakingBadge,
  },
  data() {
    return {
      dateFormat: Constants.dateFormat,
      fields: [
        {
          key: 'platform',
          label: this.$t('EXCHANGE_CURRENCY_LIST_TABLE_COMPONENT_PLATFORM_COL'),
          _style: 'min-width: 80px; text-align: left;',
        },
        {
          key: 'symbol',
          label: this.$t('EXCHANGE_CURRENCY_LIST_TABLE_COMPONENT_SYMBOL_COL'),
          _style: 'min-width: 80px; text-align: left;',
        },
        {
          key: 'name',
          label: this.$t('EXCHANGE_CURRENCY_LIST_TABLE_COMPONENT_NAME_COL'),
        },
        {
          key: 'icon',
          label: this.$t('EXCHANGE_CURRENCY_LIST_TABLE_COMPONENT_ICON_COL'),
        },
        {
          key: 'status_text',
          label: this.$t('EXCHANGE_CURRENCY_LIST_TABLE_COMPONENT_STATUS_COL'),
        },
        {
          key: 'ms_status_text',
          label: this.$t('EXCHANGE_CURRENCY_LIST_TABLE_COMPONENT_MS_STATUS_COL'),
        },
        {
          key: 'fix_rate_flg',
          label: this.$t('EXCHANGE_CURRENCY_LIST_TABLE_COMPONENT_FIXED_RATE_COL'),
          _style: 'min-width: 50px; text-align: left;',
        },
        {
          key: 'action',
          label: '',
        },
      ],
    };
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    activePage: {
      type: Number,
      default: 0,
    },
    limit: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    viewDetails(item) {
      this.$router.push(`currencies/${item.id}/details`);
    },
  },
};
</script>

<style lang="scss">
.exchange-currency-table-container {
  .exchange-currency-list-table-card {
    .table {
      margin-bottom: 0;
      .hand {
        cursor: pointer;
      }
      .btn {
        font-size: 14px;
        font-weight: 400;
        color: #0505a5;
        outline: none;
        padding-top: 0;
        padding-bottom: 0;
      }

      .currency-image {
        width: 30px;
      }

      .fixed-rate-icon {
        color: #5da30b;
      }
    }
  }
}
</style>
